import { CustomElement } from '@aurelia/runtime-html';
import * as d0 from "./signature-certification-v2.$au.ts";
export const name = "signature-box-v2";
export const template = "<template>\n  \n  <div if.bind=\"!signed\">\n    <button click.trigger:prevent=\"sign()\" class=\"btn btn-primary\">\n      Signera\n    </button>\n    <img src=\"https://apply-pub.s3.eu-north-1.amazonaws.com/apply/BankID_logo.png\" height=\"75\" width=\"75\" />\n  </div>\n  <signature-certification-v2 full-name.bind=\"fullName\" updated.bind=\"updated\" bank-id-order-ref.bind=\"bankIdOrderRef\"></signature-certification-v2>\n</template>\n";
export default template;
export const dependencies = [ d0 ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
